export default (number, digits) => String(number).padStart(digits, '0');
